/**
 * Feature flags for the Squad Fee MVP/beta.
 *
 * The multi-industry Industry-Profile architecture is intentionally
 * preserved in its entirety (backend catalog, terminology mapping,
 * per-org storage, and Settings switcher UI). For the sports-first
 * MVP launch we only *hide* the non-sports choices from normal users;
 * flipping the flag below back to `false` re-exposes the full picker
 * on Signup and Settings without any code migration.
 *
 * Do not tie other unrelated features to this flag — its sole purpose
 * is gating the industry chooser surfaces.
 */

// When true (MVP): new coaches skip the industry step and are set to
// `team_sports`; the industry switcher on Settings is hidden. Existing
// coaches keep whatever industry they had — no data migration.
export const MVP_INDUSTRY_LOCKED_TO_SPORTS = true;

// Canonical default profile id, kept next to the flag so an operator
// flipping either constant sees them together. Must match the id in
// backend/industry_profiles.py.
export const DEFAULT_INDUSTRY_PROFILE_ID = "team_sports";
